var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlans = function SvgPlans(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m2.59961 7.00156c0-.7732.6268-1.4 1.4-1.4h5c.7732 0 1.39999.6268 1.39999 1.4s-.62679 1.4-1.39999 1.4h-5c-.7732 0-1.4-.6268-1.4-1.4zm3 5.00004c0-.7732.6268-1.4 1.4-1.4h9.99999c.7732 0 1.4.6268 1.4 1.4s-.6268 1.4-1.4 1.4h-9.99999c-.7732 0-1.4-.6268-1.4-1.4zm9.39999 3.6c-.7732 0-1.4.6268-1.4 1.4s.6268 1.4 1.4 1.4h5c.7732 0 1.4-.6268 1.4-1.4s-.6268-1.4-1.4-1.4z",
    fill: "#777776",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlans, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plans.b70b36e5.svg";
export { ForwardRef as ReactComponent };